/* eslint-disable @typescript-eslint/no-explicit-any */
export function reduceReducers(...reducers: any[]) {
    return (previous: any, current: any) => reducers.reduce((p, r) => r(p, current), previous);
}
